/**
 * BLOCK: dimage-block
 *
 * Registering a basic block with Gutenberg.
 * Simple block, renders and saves the same content without any interactivity.
 */

//  Import CSS.
const __ = wp.i18n.__; // The __() for internationalization.
const registerBlockType = wp.blocks.registerBlockType; // The registerBlockType() to register blocks.
const { MediaUpload, PlainText } = wp.editor;
import { SelectControl, withState } from '@wordpress/components';

/**
 * Register: a Gutenberg Block.
 *
 * Registers a new block provided a unique name and an object defining its
 * behavior. Once registered, the block is made editor as an option to any
 * editor interface where blocks are implemented.
 *
 * @link https://wordpress.org/gutenberg/handbook/block-api/
 * @param  {string}   name     Block name.
 * @param  {Object}   settings Block settings.
 * @return {?WPBlock}          The block, if it has been successfully
 *                             registered; otherwise `undefined`.
 */
registerBlockType("dimage-360/dimage-block", {
  // Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
  title: __("Dimage 360"), // Block title.
  icon: "smiley", // Block icon from Dashicons → https://developer.wordpress.org/resource/dashicons/.
  category: "common", // Block category — Group blocks together based on common traits E.g. common, formatting, layout widgets, embed.
  keywords: [__("Dimage 360"), __("gts")],

  attributes: {
    rotate: {type: 'string',default: true},
    control: {type: 'string',default: true},
	zoom: {type: 'string',default: true},
	zoomlevel: {type: 'string',default: 0},
	speed: {type: 'string',default: 2},
	image: {type: 'string',default: ''},
	position: {type: 'string',default: 0},
  },

  
  edit: function (props) {
	function updateRotate(value) {
		props.setAttributes({rotate: value})
	  }
	  function updateControl(value) {
		props.setAttributes({control: value})
	  }
	  function updateZoom(value) {
		props.setAttributes({zoom: value})
	  }
	  function updateZoomLevel(value) {
		props.setAttributes({zoomlevel: value})
	  }
	  function updateSpeed(value) {
		props.setAttributes({speed: value})
	  }
	  function updatePosition(value) {
		props.setAttributes({position: value})
	  }
	  const isImg = props.attributes.image;
	return (
      	<div className={props.className}>

			  <h3 className="text-center">Dimage 360</h3>

			  <div className="components-base-control">
				  <div className="components-base-control__label">
					  <label>Select Image</label>
				  </div>
			  </div>
                  <MediaUpload
                    onSelect={media => {
                      const image = media.sizes.medium
                        ? media.sizes.medium.url
                        : media.url;
						props.setAttributes( { image: media.url } );
                    }}
                    type="image"
                    render={({ open }) =>
					
						<div className="col-md-4">
                        <a href="#" className="gts__picture__image btn btn-primary" onClick={open} >
                          Select Image
                        </a>
						</div>
					}
				/>
				  <div className="col-md-8">
				  {isImg ? 
						<img width="100" src={props.attributes.image} /> :
						<div class="alert alert-danger" role="alert">
							No Image Selected.
						</div>
				  }
				  </div>
				  
				  <div className="clear-both"></div>
				  <br/>

				  <div className="col-md-6">
			<SelectControl label="Auto Rotate " value={props.attributes.rotate}
				options={ [
					{ label: 'true', value: 'true' },
					{ label: 'false', value: 'false' },
				] }
				onChange={updateRotate}
			/>
			</div>

			<div className="col-md-6">
			<SelectControl label="Control " value={props.attributes.conrol}
				options={ [
					{ label: 'true', value: 'true' },
					{ label: 'false', value: 'false' },
				] }
				onChange={updateControl}
			/>
			</div>
			<div className="clear-both"></div>

			<div className="col-md-6">
			<SelectControl label="Allow Scroll to Zoom " value={props.attributes.zoom}
				options={ [
					{ label: 'true', value: 'true' },
					{ label: 'false', value: 'false' },
				] }
				onChange={updateZoom}
			/>
			</div>

			<div className="col-md-6">
			<SelectControl label="Zoom Level " value={props.attributes.zoomlevel}
				options={ [
					{ label: '0', value: '0' },
					{ label: '2', value: '2' },
					{ label: '4', value: '4' },
					{ label: '6', value: '6' },
					{ label: '8', value: '8' },
					{ label: '10', value: '10' },
					{ label: '12', value: '12' },
				] }
				onChange={updateZoomLevel}
			/>
			</div>
			
			<div className="clear-both"></div>

			<div className="col-md-6">
			<SelectControl label="Animation Speed " value={props.attributes.speed}
				options={ [
					{ label: '0', value: '0' },
					{ label: '2', value: '2' },
					{ label: '4', value: '4' },
					{ label: '6', value: '6' },
					{ label: '8', value: '8' },
					{ label: '10', value: '10' },
					{ label: '12', value: '12' },
				] }
				onChange={updateSpeed}
			/>
			</div>

			<div className="col-md-6">
			<SelectControl label="Position " value={props.attributes.position}
				options={ [
					{ label: '0', value: '0' },
					{ label: '2', value: '2' },
					{ label: '4', value: '4' },
					{ label: '6', value: '6' },
					{ label: '8', value: '8' },
					{ label: '10', value: '10' },
					{ label: '12', value: '12' },
				] }
				onChange={updatePosition}
			/>
			</div>
			
			<div className="clear-both"></div>
		</div>

	
	);
	
	
  },

  
  save: function(props) {
		return wp.element.createElement(
		"div",
		'',
		'[dimage url="'+props.attributes.image+'" control="'+props.attributes.control+'" auto-rotate="'+props.attributes.rotate+'" allow_scroll_to_zoom="'+props.attributes.zoom+'" zoom_level="'+props.attributes.zoomlevel+'" anim_speed="'+props.attributes.speed+'" default_position="'+props.attributes.position+'"]'
		);
},

deprecated: [
        {

			attributes: {
				rotate: {type: 'string',default: true},
				control: {type: 'string',default: true},
				zoom: {type: 'string',default: true},
				zoomlevel: {type: 'string',default: 0},
				speed: {type: 'string',default: 2},
				image: {type: 'string',default: ''},
				position: {type: 'string',default: 0},
				
			},
            save: function(props) {
				return wp.element.createElement(
				"div",
				'',
				'[dimage url="'+props.attributes.image+'" control="'+props.attributes.control+'" auto-rotate="'+props.attributes.rotate+'" allow_scroll_to_zoom="'+props.attributes.zoom+'" zoom_level="'+props.attributes.zoomlevel+'" anim_speed="'+props.attributes.speed+'"]'
				);
		},
        }
    ]

});
